<template>
  <div class="study-participant-response-edit-page bg-white" v-if="activity">
    <NavigationBreadcrumb :navigationWidth="navigationWidth" :redirectToProfile="true" :navigationOptions="navigationOptions"></NavigationBreadcrumb>
    <PiiAndNonPiiInfo ref="PiiAndNonPiiInfo" class="clear-both" :participantDetails="participantInfo" v-if="participantInfo" :studyData="studyData" :studyResponse="studyResponse" :isDataLoadingFinishFlag="true" @updateFlagPID="changePrtID" :userDetails="userDetails"></PiiAndNonPiiInfo>
    <!-- Task Navigation -->
    <div class="task-navigation d-flex bg-white justify-content-center align-items-center">
      <div v-if="multipleResponseSubmittedDates" v-on="!oldestResponse ? { click: () => navigateResponse(-1) } : {}" class="left-arrow" :disabled="oldestResponse">
        <span
          class="task-navigation__previous-icon fa fa-arrow-left"
          :class="{
            'arrow-disabled': oldestResponse,
            'cursor-not-allowed': areAPIInProgress
          }"
        ></span>
      </div>

      <div class="task-navigation__current-task text-center ml-45 mr-45" id="task-navigation__current-task">
        <span v-if="activityType === 'Activity'" class="current-task__title fw-500 fs-20 text-dark">{{ skinTrackerName }}</span>
        <span else class="current-task__title fw-500 fs-20 text-dark">{{ activity.name }}</span>
        <br />
        <div @click="toggleDatesDropDown" class="selectedResponse" ref="responsesDatesDropDown">
          <span v-if="activityType === 'Activity'">Completed {{ completedOn | newFormatUTCDate }}</span>
          <span v-else>{{ Number(completedOn) | formatUTCDate }}</span>
          <span class="dropdown-icon" v-if="multipleResponseSubmittedDates">
            <img src="static/img/arrow-down-blue.png" :class="{ 'cursor-not-allowed': areAPIInProgress }" />
          </span>
        </div>

        <div v-show="showResponseDropdown" class="autocomplete-items" :style="{ 'max-height': `${responseDateHeight}px` }" ref="otherResponsesDropdown">
          <div
            v-for="(submittedRes, rindex) in multipleResponseSubmittedDates"
            :key="rindex"
            class="item-detail"
            :class="{ active: rindex == selectedResponseIndex }"
            v-on="
              selectedResponseIndex != rindex
                ? {
                    click: () => {
                      changeResponse(submittedRes);
                      selectedResponseIndex = rindex;
                      showResponseDropdown = false;
                    }
                  }
                : {}
            "
          >
            <div>
              <span class="day mr-8">Day {{ submittedRes.completedDay }}</span>
              <span class="mr-10">{{ submittedRes.status }}</span>
              {{ new Date(submittedRes.completedOn) | formatUTCDate }}
              <span v-if="rindex == 0" class="day ml-10">Latest</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="multipleResponseSubmittedDates" v-on="!latestResponse ? { click: () => navigateResponse(1) } : {}" class="right-arrow" :disabled="latestResponse">
        <span
          class="task-navigation__next-icon fa fa-arrow-right"
          :class="{
            'arrow-disabled': latestResponse,
            'cursor-not-allowed': areAPIInProgress
          }"
        ></span>
      </div>
    </div>
    <!-- Activity Status -->
    <ParticipantActivityResponseActivityDetails
      :surveyId="surveyId"
      :surveyResponseStatus="surveyResponseStatus"
      v-if="surveyResponseStatus && participantInfo"
      :revisionId="revisionId"
      @onChangeStatus="onChangeStatus"
      :userRoles="userRoles"
      :languages="languages"
      :activityLanguageCulture="activityLanguageCulture"
      :selectedLanguageCulture="selectedLanguageCulture"
      @onSelectedLanguageCultureChange="onSelectedLanguageCultureChange"
      :participantDetails="participantInfo"
      :participantId="participantId"
      :activity="activity"
    />

    <!-- Participant Responses -->
    <div class="main participant-responses" v-if="surveyData">
      <div class="row tabs-container no-gutters pb-130 position-relative" ref="tabsContainer">
        <div class="tabs-container__left" :class="ishideQuery == true ? 'col-lg-12' : 'col-xl-8 col-7'">
          <b-tabs v-model="currentTab">
            <b-tab title="Latest Version" :title-link-class="'tabs-details'" @click="ishideQuery = false">
              <EditableParticipantActivityResponse
                :_participantResponses="participantResponses"
                :questionDetails="questionDetails"
                :userRoles="userRoles"
                @selectField="onFieldSelect"
                :selectedQuestionId="selectedQuestionId"
                @openNewQuery="onCreateNewQuery"
                :openQueriesToQuestionMap="openQueriesToQuestionMap"
                @onConfirmEdit="postEditedAnswers"
                v-if="participantResponses && questionDetails"
                :surveyData="surveyData"
                :activityLanguageCulture="activityLanguageCulture"
                :selectedLanguageCulture="selectedLanguageCulture"
                @changeEditMode="setIsEditModeActive"
                :isEditModeActive="isEditModeActive"
                :isPostEditAnswerAPICallInProgress="isPostEditAnswerAPICallInProgress"
                :questionsMLOptions="questionIdToMLOptions"
                :questionIdToCustomLabels="questionIdToCustomLabels"
                :questionIdToNumberScaleLabels="questionIdToNumberScaleLabels"
                :totalScore="totalScore"
                :totalScoreValue="totalScoreValue"
                :studyId="studyId"
                :study-data="studyData"
                :queries="openQueries"
                :surveyResponseStatus="surveyResponseStatus"
              />
            </b-tab>
            <b-tab
              title="History"
              :title-link-class="'tabs-details'"
              @click="ishideQuery = false"
              v-on:click="showWarningModal()"
              v-if="surveyData.editCheckAllowed && (userRoles.canDmAccess || userRoles.canCraAccess || userRoles.canCraUBAccess || userRoles.canPharmacovigilanceAccess || userRoles.canPiAccess || userRoles.canSubPiAccess || userRoles.canStudyCoordinatorAccess || userRoles.canHomeHealthAccess || userRoles.canCallCenterAccess || userRoles.canSiteDataLockAccess)"
            >
              <ParticipantActivityResponseHistory
                :participantInfo="participantInfo"
                :participantResponses="participantResponses"
                :historylist="historylist"
                :questionDetails="questionDetails"
                :surveyId="surveyId"
                :surveyData="surveyData"
                :userRoles="userRoles"
                :selectedLanguageCulture="selectedLanguageCulture"
                @hideQuery="hideQuery"
                @displayQuery="ishideQuery = false"
                :surveyResponseTrackerId="surveyResponseTrackerId"
                v-if="participantInfo && historylist"
              />
            </b-tab>
            <b-tab
              title="Source Documents"
              :title-link-class="'tabs-details'"
              class="col-md-12"
              v-on:click="hideQuery()"
              v-if="userRoles.canPiAccess || userRoles.canSubPiAccess || userRoles.canStudyCoordinatorAccess || userRoles.canHomeHealthAccess || userRoles.canSysAdminAccess || userRoles.canStudyAdminAccess || userRoles.canSiteDataLockAccess || userRoles.canCallCenterAccess || userRoles.canCraUBAccess"
            >
              <ParticipantActivityResponseSourceDocuments :_documentlist="documentlist" :userRoles="userRoles" :surveyId="surveyId" :revisionId="revisionId" @getDocumentsList="getSourceDocumentList" :surveyResponseTrackerId="surveyResponseTrackerId" :participantId="participantId" />
            </b-tab>
            <b-tab 
              v-if="showAdditionalScores"
              title="Additional Scores"
              :title-link-class="'tabs-details'"
              @click="ishideQuery=false"
            >
              <EdcFormAdditionalScores :variablesList="variablesList" :surveyId="surveyId" :studyId="studyId" :activityId="activityId" :participantId="participantId" :activityRevisionId="this.activityRevisionId" :reportedDataTrackerId="reportedDataTrackerId"
            />
          </b-tab>
          </b-tabs>
        </div>
        <div class="col-xl-4 col-5 bg-white position-relative queries-container" v-if="!ishideQuery && !activityData">
          <ParticipantActivityResponseQueries
            @postNewQuery="onPostingNewQuery"
            @cancelCreateQuery="isQueryInEditMode = false"
            :surveyId="surveyId"
            :studyId="studyId"
            :activityQueries="activityQueries"
            :queries="selectedQuestionQueries"
            :lockStatus="surveyResponseStatus && surveyResponseStatus.lock_status"
            :selectedQuestionId="selectedQuestionId"
            :isQueryInEditMode="isQueryInEditMode"
            @refreshQueries="refreshQueries"
            :revisionId="revisionId"
            :userRoles="userRoles"
            @onChangeQuestionId="onChangeQuestionId"
            :surveyResponseTrackerId="surveyResponseTrackerId"
            :participantId="participantId"
          />
        </div>
      </div>
    </div>
    <!-- For Activity Data  -->
    <div class="main participant-responses" v-if="activityData">
      <div class="row tabs-container no-gutters pb-130 position-relative" ref="tabsContainer">
        <div class="tabs-container__left col-lg-12">
          <b-tabs v-model="currentTab">
            <b-tab title="Latest Version" :title-link-class="'tabs-details'" @click="ishideQuery = false">
              <ParticipantEdroResponsePreview v-if="activityData" :activityData="activityData" />
            </b-tab>
            <b-tab
              title="Source Documents"
              :title-link-class="'tabs-details'"
              class="col-md-12"
              v-on:click="hideQuery()"
              v-if="userRoles.canCraUBAccess || userRoles.canPiAccess || userRoles.canSubPiAccess || userRoles.canStudyCoordinatorAccess || userRoles.canHomeHealthAccess || userRoles.canSysAdminAccess || userRoles.canStudyAdminAccess || userRoles.canSiteDataLockAccess || userRoles.canCallCenterAccess"
            >
              <ParticipantActivityResponseSourceDocuments :_documentlist="documentlist" :userRoles="userRoles" :surveyId="surveyId" :revisionId="revisionId" @getDocumentsList="getSourceDocumentList" :surveyResponseTrackerId="surveyResponseTrackerId" :participantId="participantId" />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <!-- End  -->
    <b-modal id="editFormModal" ref="editFormModal" hide-footer hide-header :no-close-on-esc="true" :no-close-on-backdrop="true">
      <b-row class="pt-20 width-500 border-style text-center">
        <b-col align-self="center" class="pb-0 pl-0">
          <h2>
            <b>Warning</b>
          </h2>
        </b-col>
      </b-row>
      <b-row class="text-center">
        <b-col align-self="center" class="pb-5 pt-5">
          Are you sure you want to cancel editing this activity?
        </b-col>
      </b-row>
      <b-row class="pt-20 pb-40 justify-content-center">
        <b-col cols="3" class="mr-30">
          <b-btn class="btn-block fs-14" variant="secondary" v-on:click="hidewarningtModal(false)">
            No
          </b-btn>
        </b-col>
        <b-col cols="3">
          <b-btn class="btn-block fs-14 error-bg primaryBgColor" variant="primary" v-on:click="hidewarningtModal(true)">
            Yes
          </b-btn>
        </b-col>
      </b-row>
      <div class="modal-style"></div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import ParticipantActivityResponseActivityDetails from "@/components/participants/activity-response/participant-activity-response-activity-details.vue";
import EditableParticipantActivityResponse from "@/components/participants/activity-response/editable-participant-activity-response.vue";
import ParticipantActivityResponseQueries from "@/components/participants/activity-response/participant-activity-response-queries";
import ParticipantActivityResponseHistory from "@/components/participants/activity-response/participant-activity-response-history";
import ParticipantActivityResponseSourceDocuments from "@/components/participants/activity-response/participant-activity-response-source-documents";
import moment from "moment";
import EdcFormAdditionalScores from "@/components/form/edc-form-additional-scores";
import { AclRule } from "vue-acl";
import NavigationBreadcrumb from "@/components/common/navigation-breadcrumb";
import PiiAndNonPiiInfo from "@/components/participants/pii-and-non-pii-info";
import MultilingualService from "@/components/services/multilingual-service";
import ParticipantEdroResponsePreview from "@/components/participants/activity-response/participant-edro-response-preview.vue";
import localStorageService from "../../services/localStorage";
import { PI, CC, SUB_PI, STUDY_COORDINATOR, CRA, DM, HOME_HEALTH, QUALITY, BSTAT, PHV, SYSTEM_ADMIN, STUDY_ADMIN, STUDY_MANAGER, SITEDATALOCK, CraUB, RATER, INTERVIEWER } from "@/constants/authRoles";
import * as activityService from "@/components/services/activity-service";
export default {
  name: "study-participant-response-edit",
  props: ["studyData"],
  components: {
    PiiAndNonPiiInfo,
    EditableParticipantActivityResponse,
    ParticipantActivityResponseQueries,
    ParticipantActivityResponseActivityDetails,
    ParticipantActivityResponseHistory,
    ParticipantActivityResponseSourceDocuments,
    EdcFormAdditionalScores,
    NavigationBreadcrumb,
    ParticipantEdroResponsePreview
  },
  data() {
    return {
      surveyResponseStatus: null,
      participantResponses: null,
      surveyDetails: null,
      totalScore: 0,
      isQueryInEditMode: false,
      surveyData: null,
      activityQueries: null,
      selectedQuestionId: null,
      revisionId: null,
      surveyID: null,
      ishideQuery: false,
      historylist: null,
      documentlist: null,
      surveyResponseTrackerId: null,
      activityLanguageCulture: null,
      studyLanguageId: "ca0af64b-9a40-11e9-8a9c-12046093208c",
      selectedLanguageCulture: "EN",
      multipleResponseSubmittedDates: null,
      selectedResponseIndex: null,
      activity: {},
      showResponseDropdown: false,
      responseDateHeight: 200,
      eventListenerToHideDropdown: null,
      isEditModeActive: false,
      currentTab: 0,
      participantInfo: null,
      navigationOptions: [],
      navigationWidth: "76%",
      generalParticipantInfo: {},
      areAPIInProgress: false,
      isPostEditAnswerAPICallInProgress: false,
      allApplangaKeys: {},
      questionIdToMLOptions: {},
      questionIdToCustomLabels: {},
      questionIdToParticipantResponseMap: {},
      questionIdToNumberScaleLabels: {},
      totalScoreValue: "",
      mlService: {},
      openQueries: [],
      studyResponse: {},
      activityData: [],
			userDetails: {},
      variablesList:[],
      activityRevisionId:''
    };
  },
  filters: {
    getFormattedDateForDropdown(value) {
      const datemoment = moment.utc(Number(value));
      const date = datemoment.format("MMMM D YYYY");
      const time = datemoment.format("hh:mm A");
      const formatted = `${date} at  ${time} UTC`;
      return formatted;
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    participantId() {
      return this.$route.params.participantId;
    },
    activityId() {
      return this.$route.query.activityId;
    },
    studyId() {
      return this.$route.params.studyId;
    },
    surveyId() {
      return this.$route.query.activityId;
    },
    activityType() {
      return this.$route.query.type;
    },
    reportedDataTrackerId() {
      return this.$route.query.reportedDataTrackerId;
    },
    completedOn() {
      return this.$route.query.completedOn;
    },
    skinTrackerName() {
      return this.$route.params.name;
    },
    allStudyLanguages() {
      if (this.studyData) {
        return this.studyData.language;
      }
      return [];
    },
    languages() {
      if (this.allStudyLanguages && this.allStudyLanguages instanceof Array && this.allStudyLanguages.length) {
        const languages = [];

        const responseLanguage = this.allStudyLanguages.find(language => language.language_culture === this.activityLanguageCulture);
        if (responseLanguage) {
          languages.push(responseLanguage);
        }
        if (responseLanguage.name !== "English") {
          const englishLanguage = this.allStudyLanguages.find(language => language.name === "English");
          if (englishLanguage) {
            languages.push(englishLanguage);
          }
        }

        if (languages.length) {
          return languages;
        }

        return [];
      }
      return [];
    },
    latestResponse() {
      if (!this.multipleResponseSubmittedDates) {
        return;
      }
      return this.selectedResponseIndex == 0;
    },
    oldestResponse() {
      if (!this.multipleResponseSubmittedDates) {
        return;
      }
      return this.selectedResponseIndex == this.multipleResponseSubmittedDates.length - 1;
    },
    reqParamsForGettingParticipantResponse() {
      if (!this.activity) {
        return null;
      }
      const { activityId, completedOn, reportedDataTrackerId, type } = this.$route.query;

      const { participantId, studyId } = this.$route.params;

      if (type && type.toLowerCase && type.toLowerCase() === "survey") {
        if ((studyId, participantId && activityId && completedOn && reportedDataTrackerId)) {
          return {
            studyId,
            pid: participantId,
            surveyId: activityId,
            responseDate: completedOn,
            reportedDataTrackerId
          };
        }
      } else if (type && type.toLowerCase && type.toLowerCase() === "activity") {
        if ((studyId, participantId && activityId && completedOn)) {
          return {
            studyId,
            pid: participantId,
            activityId,
            completedOn
          };
        }
      }
      return null;
    },
    questionDetails() {
      if (!this.surveyData) {
        return null;
      }

      return this.surveyData.questions || null;
    },
    queryDataObj() {
      if (!this.activityQueries) {
        return null;
      }
      const queryDataObj = {};
      this.activityQueries.forEach(query => {
        queryDataObj[query.question_id] ? queryDataObj[query.question_id].push(query) : (queryDataObj[query.question_id] = [query]);
      });
      return queryDataObj;
    },
    selectedQuestionQueries() {
      if (!this.selectedQuestionId || !this.queryDataObj) {
        return null;
      }
      const qid = this.selectedQuestionId;
      return this.queryDataObj[qid] ? this.queryDataObj[qid] : [];
    },
    openQueriesToQuestionMap() {
      if (!this.queryDataObj) {
        return null;
      }

      const questionToOpenQueryMap = {};
      Object.keys(this.queryDataObj).forEach(questionId => {
        if (this.queryDataObj[questionId] && this.queryDataObj[questionId]) {
          const hasOpenQuery = this.queryDataObj[questionId].find(query => query.status == 0);
          if (hasOpenQuery) {
            questionToOpenQueryMap[questionId] = true;
            return;
          }
        }
        questionToOpenQueryMap[questionId] = false;
      });

      return questionToOpenQueryMap;
    },
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canCallCenterAccess() {
      this.$acl.change(`${CC}`);
      return this.$acl.check("userAccess");
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canSubPIAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyCoordinatorAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canCraAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    },
    canDmAccess() {
      this.$acl.change(`${DM}`);
      return this.$acl.check("userAccess");
    },
    canQualityAccess() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    canBioStatisticsAccess() {
      this.$acl.change(`${BSTAT}`);
      return this.$acl.check("userAccess");
    },
    canPharmacovigilanceAccess() {
      this.$acl.change(`${PHV}`);
      return this.$acl.check("userAccess");
    },
    canSiteDataLockAccess() {
      this.$acl.change(`${SITEDATALOCK}`);
      return this.$acl.check("userAccess");
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    },
    canInterviewerAccess(){
      this.$acl.change(`${INTERVIEWER}`);
      return this.$acl.check("userAccess");
    },
    canRaterAccess() {
      this.$acl.change(`${RATER}`);
      return this.$acl.check("userAccess");
    },
    userRoles() {
      return {
        canStudyAdminAccess: this.canStudyAdminAccess,
        canCraAccess: this.canCraAccess,
        canPiAccess: this.canPiAccess,
        canSysAdminAccess: this.canSysAdminAccess,
        canSubPiAccess: this.canSubPIAccess,
        canStudyCoordinatorAccess: this.canStudyCoordinatorAccess,
        canHomeHealthAccess: this.canHomeHealthAccess,
        canCallCenterAccess: this.canCallCenterAccess,
        canDmAccess: this.canDmAccess,
        canQualityAccess: this.canQualityAccess,
        canBioStatisticsAccess: this.canBioStatisticsAccess,
        canPharmacovigilanceAccess: this.canPharmacovigilanceAccess,
        canSiteDataLockAccess: this.canSiteDataLockAccess,
        canStudyManagerAccess: this.canStudyManagerAccess,
        canCraUBAccess: this.canCraUBAccess,
        canRaterAccess: this.canRaterAccess
      };
    },
    isDetailedActivityPageAccessable() {
      if (!this.user) {
        return false;
      }
      const rolesThatCanAccessDetailedActivityPage = [PI, SUB_PI, STUDY_COORDINATOR, CRA, DM, HOME_HEALTH, QUALITY, SYSTEM_ADMIN, STUDY_ADMIN, STUDY_MANAGER, BSTAT, PHV, CC, CraUB];
      const currentUserRole = this.user.userRole;
      if (rolesThatCanAccessDetailedActivityPage.indexOf(currentUserRole) === -1) {
        return false;
      }
      return true;
    },
    showAdditionalScores(){
      if(this.variablesList && this.variablesList.length > 0 && !this.canInterviewerAccess){
        return true;
      }
      return false;
    }
  },
  watch: {
    surveyResponseTrackerId:{
      handler(value){
        if (value){
          this.getActivityRevision()
        }
      }
    }
  },
  methods: {
    showWarningModal() {
      if (this.isEditModeActive) {
        this.$refs.editFormModal.show();
      }
    },

    hidewarningtModal(isCancelEdit) {
      if (isCancelEdit) {
        this.isEditModeActive = false;
      } else {
        this.currentTab = 0;
      }
      this.$refs.editFormModal.hide();
    },

    onPostQuery() {
      this.isQueryInEditMode = false;
      this.getQueriesData();
    },

    setIsEditModeActive(status) {
      this.isEditModeActive = status;
    },

    async onSelectedLanguageCultureChange(languageCulture) {
      this.selectedLanguageCulture = languageCulture;
      for (let i = 0; i < this.languages.length; i++) {
        if (this.languages[i].language_culture == languageCulture) {
          this.studyLanguageId = this.languages[i].language_id;
          await this.mlService.loadAppLangaKeys(this.$route, this.studyLanguageId);
        }
      }
      const activityRevisionId = this.surveyData.revisionId ? this.surveyData.revisionId : null;
      this.mlService.getAllQuestionTypeConversion(this.surveyData.questions, this.participantResponses, this.selectedLanguageCulture, activityRevisionId).then(
        result => {
          this.participantResponses = result.response;
          if (languageCulture !== "EN") {
            this.surveyData.questions = result.questions;
          } else {
            this.questionIdToMLOptions = _.cloneDeep(result.questions);
          }
        },
        () => {
          this.questionIdToMLOptions = this.surveyData.questions;
        }
      );
    },
    generateApplangaKeyForBoolean(questionId, optionId) {
      const booleanApplangaKey = questionId + "_options_" + optionId + "_label";
      const convertedAnswer = this.allApplangaKeys[this.activityLanguageCulture] && this.allApplangaKeys[this.activityLanguageCulture]["main"]["entries"][booleanApplangaKey].v;
      const boolAnswer = {};
      boolAnswer.body = convertedAnswer;
    },
    generateApplangaForNumberScale(question) {
      const labels = [];
      let minLabel = null;
      let maxLabel = null;
      const minValue = question.minValue;
      const minApplangaKey = question.id + "_minvalue";
      const maxApplangaKey = question.id + "_maxvalue";
      const answerText = this.questionIdToParticipantResponseMap[question.id].answerText;

      if (this.allApplangaKeys[this.activityLanguageCulture] && this.allApplangaKeys[this.activityLanguageCulture]["main"]["entries"].hasOwnProperty(maxApplangaKey)) {
        maxLabel = question.maxValue;
      } else {
        maxLabel = question.maxValue;
      }

      if (this.allApplangaKeys[this.activityLanguageCulture] && this.allApplangaKeys[this.activityLanguageCulture]["main"]["entries"].hasOwnProperty(minApplangaKey)) {
        minLabel = question.minValue;
      } else {
        minLabel = question.minValue;
      }

      let x = 1;
      let iterator = minValue;
      while (x < question.intervals) {
        iterator += question.partitions;
        labels.push(iterator);
        x++;
      }

      return {
        labels: labels,
        min: minLabel,
        max: maxLabel,
        displayAnswerText: parseFloat(answerText)
      };
    },
    generateApplangaForMultichoice(questionId, options) {
      const multiLingualOptions = [];
      options.forEach(option => {
        const multiLingualOption = {};
        let convertedOption;
        const booleanApplangaKey = questionId + "_options_" + option.id + "_label";
        if (this.allApplangaKeys[this.activityLanguageCulture] && this.allApplangaKeys[this.activityLanguageCulture]["main"]["entries"].hasOwnProperty(booleanApplangaKey)) {
          convertedOption = this.allApplangaKeys[this.activityLanguageCulture] && this.allApplangaKeys[this.activityLanguageCulture]["main"]["entries"][booleanApplangaKey].v;
        } else {
          convertedOption = option.body;
        }
        multiLingualOption.id = option.id;
        multiLingualOption.body = convertedOption;
        multiLingualOptions.push(multiLingualOption);
      });
      return multiLingualOptions;
    },
    generateApplangaForCustomScale(questionId, labels) {
      const customScaleLabel = [];
      let count = 0;
      let convertedLabel;
      labels.forEach(label => {
        const createCustomApplangaKey = questionId + "_labels_" + count + "_label";
        count++;
        if (this.allApplangaKeys[this.activityLanguageCulture] && this.allApplangaKeys[this.activityLanguageCulture]["main"]["entries"].hasOwnProperty(createCustomApplangaKey)) {
          convertedLabel = this.allApplangaKeys[this.activityLanguageCulture] && this.allApplangaKeys[this.activityLanguageCulture]["main"]["entries"][createCustomApplangaKey].v;
        } else {
          convertedLabel = label;
        }
        customScaleLabel.push(convertedLabel);
      });
      return customScaleLabel;
    },
    getApplangaKeys() {
      this.$api.getApplangaCredentials(this.$route.params.studyId).then(
        response => {
          const time = new Date().getTime();
          const appId = response.body.data.applicationId;
          const appToken = response.body.data.applanagaTokenId;
          //** Axios Code */
          axios({
            method: "get",
            crossDomain: true,
            url: `https://api.applanga.com/v1/api?app=${appId}&includeUpdateDate=true#${time}`,
            headers: {
              Authorization: `Bearer ${appToken}`
            }
          })
            .then(response => {
              if (response) {
                this.allApplangaKeys = response.data.data;
              }
            })
            .catch(err => {
              throw err;
            });
          //** Axios Code */
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while uploading the document.");
        }
      );
    },
    //for Edit
    generateApplangaKeyForAllQuestionTypes() {
      this.surveyData.questions.forEach(question => {
        if (question.type != "SurveyCompletion") {
          const allOptionBody = [];
          let convertedQuestionBody;
          this.$set(this.questionIdToMLOptions, question.id, {});
          this.$set(this.questionIdToCustomLabels, question.id, {});
          this.$set(this.questionIdToNumberScaleLabels, question.id, {});

          const queBodyAppLangaKey = question.id + "_body";
          if (this.allApplangaKeys[this.activityLanguageCulture] && this.allApplangaKeys[this.activityLanguageCulture]["main"]["entries"].hasOwnProperty(queBodyAppLangaKey)) {
            convertedQuestionBody = this.allApplangaKeys[this.activityLanguageCulture] && this.allApplangaKeys[this.activityLanguageCulture]["main"]["entries"][queBodyAppLangaKey].v;
          } else {
            convertedQuestionBody = question.body;
          }
          this.questionIdToMLOptions[question.id].questionBody = convertedQuestionBody;

          if (question.type == "MultiChoice" || question.type == "Boolean") {
            const multiChoiceConvertedOptions = this.generateApplangaForMultichoice(question.id, question.options);
            multiChoiceConvertedOptions.forEach(multiChoiceConvertedOption => {
              allOptionBody.push(multiChoiceConvertedOption.body);
            });
            const displayAnswerText = this.getDisplayAnsText(question.id, multiChoiceConvertedOptions);
            this.$set(this.questionIdToMLOptions[question.id], "options", multiChoiceConvertedOptions);
            this.$set(this.questionIdToMLOptions[question.id], "displayAnswerText", displayAnswerText);
          } else if (question.type == "CustomScale") {
            const customScaleConvertedOptions = this.generateApplangaForCustomScale(question.id, question.labels);
            const answerText = this.questionIdToParticipantResponseMap[question.id].answerText;
            const labelIndex = question.labels.indexOf(answerText);
            const displayAnswerText = customScaleConvertedOptions[labelIndex];
            this.$set(this.questionIdToCustomLabels[question.id], "labels", customScaleConvertedOptions);
            this.$set(this.questionIdToCustomLabels[question.id], "displayAnswerText", displayAnswerText);
          } else if (question.type == "NumberScale") {
            const numberScaleConvertedOptions = this.generateApplangaForNumberScale(question);
            const labels = numberScaleConvertedOptions.labels;
            labels.unshift(numberScaleConvertedOptions.min);
            labels.push(numberScaleConvertedOptions.max);
            this.$set(this.questionIdToNumberScaleLabels[question.id], "labels", labels);
            this.$set(this.questionIdToNumberScaleLabels[question.id], "displayAnswerText", numberScaleConvertedOptions.displayAnswerText);
          }
        }
      });
    },
    getParticipantResponses() {
      if (!this.reqParamsForGettingParticipantResponse || this.areAPIInProgress) {
        return;
      }
      this.areAPIInProgress = true;
      this.$api.getSurvey(this.reqParamsForGettingParticipantResponse).then(
        data => {
          this.activityData = data.responseList;
          this.surveyDetails = data;
          this.surveyID = this.surveyDetails.responses[0].surveyId;
          this.revisionId = this.surveyDetails.responses[0].revisionId;
          this.surveyResponseTrackerId = this.surveyDetails.responses[0].surveyResponseTracker.id;
          this.activityLanguageCulture = this.surveyDetails.responses[0].displayLanguage;
          this.studyLanguageId = this.surveyDetails.responses[0].appLanguageId;
          this.participantResponses = _.sortBy(data.responses, "sequence");
          this.activity.name = this.surveyDetails.surveyName;
          this.totalScore = this.surveyDetails.activityTotalScore || 0;
          this.generateQuestionIdToParticipantResponseMap();
          this.totalScoreValue = data.totalScore ? data.totalScore : 0;

          Promise.all([this.getSurveyData(), this.getQueriesData(), this.getOpenQueries(), this.getHistoryList(), this.getSourceDocumentList(), this.getApproveVerifyStatus(), this.getParticipantDetails()])
            .then(() => {
              this.areAPIInProgress = false;
              const activityRevisionId = this.surveyData.revisionId ? this.surveyData.revisionId : null;
              this.mlService.getAllQuestionTypeConversion(this.surveyData.questions, this.participantResponses, this.selectedLanguageCulture, activityRevisionId).then(
                result => {
                  this.participantResponses = result.response;
                  this.surveyData.questions = result.questions;
                  this.questionIdToMLOptions = _.cloneDeep(result.questions);
                },
                () => {
                  this.questionIdToMLOptions = this.surveyData.questions;
                }
              );
            })
            .catch(() => {
              this.areAPIInProgress = false;
            });
        },
        error => {
          const { message = "Error while survey request" } = (error && error.body) || {};
          this.$toastr.error(message);
        }
      );
    },
    //for get
    generateQuestionIdToParticipantResponseMap() {
      this.participantResponses.forEach(participantResponse => {
        this.questionIdToParticipantResponseMap[participantResponse.questionId] = participantResponse;
      });
    },
    getDisplayAnsText(questionId, multiLingualOptions) {
      const selectedOptions = this.questionIdToParticipantResponseMap[questionId].optionId.split(",");
      const allOptionBody = [];
      selectedOptions.forEach(selectedOption => {
        const multiLingualOption = multiLingualOptions.find(multiLingualOption => multiLingualOption.id == selectedOption);
        if (multiLingualOption) {
          allOptionBody.push(multiLingualOption.body);
        }
      });
      const displayAnswerText = allOptionBody.join(",");
      return displayAnswerText;
    },
    getDisplayAnsForCustomScale(questionId) {
      const selectedOptions = this.questionIdToParticipantResponseMap[questionId].displayAnswerText;
      const displayAnswerText = selectedOptions;
      return displayAnswerText;
    },
    getSurveyData() {
      return this.$api.getSurveyDetailsFact(this.studyId, this.surveyId, "Survey").then(
        response => {
          this.surveyData = response.body;
        },
        error => {
          this.errorMsg = error.body ? error.body.message : "Error while getting survey details";
          this.$toastr.error(this.errorMsg);
        }
      );
    },
    getOpenQueries() {
      return this.$api.getSurveyResponseOpenQuery(this.surveyID, this.revisionId, this.participantId).then(response => {
        this.openQueries = response.data.data;
      });
    },
    async getQueriesData() {
      await this.delay(4000);
      return this.$api
        .getSurveyResponseQuery(this.surveyID, this.revisionId, this.participantId)
        .then(response => {
          const data = response.data && response.data.data;
          if (!data) {
            return (this.activityQueries = null);
          }
          if (data instanceof Array && data.length === 0) {
            return (this.activityQueries = null);
          }

          let { queries, replies } = response.data && response.data.data;

          if (typeof replies === "string") {
            replies = [];
          }

          if (!replies) {
            replies = [];
          }

          queries.forEach(query => {
            let comments = replies.find(comment => comment[0].query_id === query.id);
            if (comments && comments.length) {
              comments = comments.sort((a, b) => new Date(b.created_time) - new Date(a.created_time));
              comments.push({ ...query, notes: query.query_content });
            } else {
              comments = [];
              comments.push({ ...query, notes: query.query_content });
            }
            query.replies = comments && comments.length ? comments : [];
            // query.status = 1;
          });

          if (queries.length > 0) {
            queries = queries.sort((a, b) => new Date(b.created_time) - new Date(a.created_time));
          }

          this.activityQueries = queries;
        })
        .catch(() => {
          this.activityQueries = null;
          if (this.surveyID) {
            this.$toastr.error("Error while getting queries");
          }
        });
    },
    async getApproveVerifyStatus() {
      await this.delay(4000);
      return this.$api
        .getStudyResponseStatus(this.surveyID, this.revisionId, "status")
        .then(response => {
          this.surveyResponseStatus = response.data.data[0];
        })
        .catch(() => {
          this.surveyResponseStatus = null;
          if (this.surveyID) {
            this.$toastr.error("Error while getting approval and verifcation status");
          }
        });
    },
    onChangeStatus() {
      this.getApproveVerifyStatus();
      this.getHistoryList();
    },
    onFieldSelect(question) {
      this.isQueryInEditMode = false;
      if (!question) {
        this.selectedQuestionId = null;
        return;
      }
      this.selectedQuestionId = question.questionId;
    },
    refreshQueries() {
      this.getQueriesData();
    },
    onCreateNewQuery(questionId) {
      this.selectedQuestionId = questionId;
      this.isQueryInEditMode = true;
    },
    onPostingNewQuery() {
      this.isQueryInEditMode = false;
      this.refreshQueries();
    },
    getHistoryList() {
      const surveyTrackerId = this.activityId ? this.activityId : this.$route.query.activityId;
      if (!surveyTrackerId || surveyTrackerId == "") {
        return;
      }
      return this.$api
        .getStudyResponseHistory(this.surveyId, this.participantId, this.studyId, this.surveyResponseTrackerId)
        .then(response => {
          this.historylist = response.data && response.data.data;
        })
        .catch(() => {
          this.historylist = null;
          this.$toastr.error("Error while getting history list");
        });
    },
    // get the participant details
    getParticipantDetails() {
      return this.$api.getParticipantDataFactV2(this.studyId, this.participantId).then(
        response => {
          this.participantInfo = response.body;
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participant.");
        }
      );
    },
    async getSourceDocumentList() {
      await this.delay(4000);
      return this.$api
        .getSurveyResponseSourceDocuments(this.surveyID, this.revisionId)
        .then(response => {
          this.documentlist = response.data && response.data.data;
        })
        .catch(() => {
          this.documentlist = null;
          if (this.surveyID) {
            this.$toastr.error("Error while getting source documents");
          }
        });
    },
    hideQuery() {
      this.ishideQuery = true;
    },
    onChangeQuestionId(questionId) {
      this.selectedQuestionId = questionId;
    },
    postEditedAnswers({ requestBody, done }) {
      requestBody.responses.filter(each => {
        if (each.questionType == "Number") {
          each.answerText = each.displayAnswerText;
          return each;
        } else if (each.questionType === "NumberScale" && each.isSkipped) {
          each.answerText = "";
        } else {
          return each;
        }
      });
      requestBody.createdBy = `${this.userDetails.firstName} ${this.userDetails.lastName}`;
      this.isPostEditAnswerAPICallInProgress = true;
      return this.$api
        .updateSurveyResponse(this.surveyId, this.revisionId, requestBody)
        .then(() => {
          done();
          this.isPostEditAnswerAPICallInProgress = false;
          this.getParticipantResponses();
          this.getHistoryList();
          this.$root.$emit('updateScoreValueTab');
        })
        .catch(() => {
          this.isPostEditAnswerAPICallInProgress = false;
          this.$toastr.error("Error while editing response");
        });
    },

    getActivitySubmmitedList() {
      //Get all the submitted response for the survey being shown
      const id = this.activityId ? this.activityId : this.$route.query.activityId;
      const type = this.activityType ? this.activityType : this.$route.query.type;
      if (!id || !type || type == "" || id == "") {
        return;
      }
      const getReq = {
        studyId: this.studyId,
        pid: this.participantId,
        id: id,
        startDay: this.generalParticipantInfo.startDay,
        endDay: this.generalParticipantInfo.endDay,
        type: type
      };

      this.$api.getSurveyResponsesList(getReq).then(
        data => {
          this.otherSubmittedResponse = data;
          if (data.length > 1) {
            const sortDataAsc = _.sortBy(data, ["completedOn"]);
            this.multipleResponseSubmittedDates = _.reverse(sortDataAsc); //Order by date so that latest comes first

            //Find the index of the response being displayed
            const responseType = this.activity.type.toLowerCase();
            if (responseType == "survey") {
              this.selectedResponseIndex = _.findIndex(this.multipleResponseSubmittedDates, ["reportedDataTrackerId", this.activity.reportedDataTrackerId]);
            } else {
              this.selectedResponseIndex = _.findIndex(this.multipleResponseSubmittedDates, ["id", this.activity.reportedDataTrackerId]);
            }
          }
        },
        error => {
          const { message = "Error while all submitted response" } = (error && error.body) || {};
          this.$toastr.error(message);
        }
      );
      // }
    },

    navigateResponse(move) {
      this.showResponseDropdown = false;
      if (this.areAPIInProgress) {
        return;
      }
      if (move == 1) {
        this.selectedResponseIndex = this.selectedResponseIndex - 1;
      } else {
        this.selectedResponseIndex = this.selectedResponseIndex + 1;
      }
      this.changeResponse(this.multipleResponseSubmittedDates[this.selectedResponseIndex]);
    },

    changeResponse(activity) {
      this.activity = activity;
      // let {completedOn}

      const { id, completedOn, reportedDataTrackerId, type, studyId, participantId } = this.activity;

      this.$router.push({
        name: "study-participant-activity-response-edit",
        query: { activityId: id, completedOn, reportedDataTrackerId, type },
        params: { studyId, participantId }
      });
      this.getParticipantResponses();
    },

    toggleDatesDropDown() {
      if (this.areAPIInProgress) {
        return;
      }
      this.showResponseDropdown = !this.showResponseDropdown;
      if (this.showResponseDropdown) {
        this.$refs.otherResponsesDropdown.focus();
      }
    },

    addEventListenerToHideDropdown() {
      this.eventListenerToHideDropdown = document.addEventListener("click", event => {
        if (!this.$refs.responsesDatesDropDown) {
          return;
        }
        if (!this.$refs.responsesDatesDropDown.contains(event.target)) {
          this.showResponseDropdown = false;
        }
      });
    },

    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    setActivityDetails() {
      this.activity = {};

      this.activity.studyId = this.studyId;
      this.activity.participantId = this.participantId;
      this.activity.id = this.activtyId;
      this.activity.completedOn = this.completedOn;
      this.activity.reportedDataTrackerId = this.reportedDataTrackerId;
      this.activity.type = this.activityType;
    },

    setNavigationOptions() {
      this.navigationOptions = [
        {
          name: this.activityType === "Activity" ? "eDRO" : this.activityType,
          isLink: false,
          route: null,
          params: null,
          displayOrder: 3
        },
        {
          name: "Profile",
          isLink: true,
          route: "participant-profile",
          params: { studyId: this.studyId, participantId: this.participantId },
          displayOrder: 2
        },
        {
          name: "Participants",
          isLink: true,
          route: "study-participants-list",
          params: { studyId: this.studyId },
          displayOrder: 1
        }
      ];
    },

    getAllParticipantDetails() {
      return this.$api
        .participantFullDetail(this.studyId, this.participantId, false)
        .then(response => {
          this.generalParticipantInfo.startDay = 1;
          this.generalParticipantInfo.endDay = parseInt((response.body.studyEndDate - response.body.studyStartDate) / (1000 * 60 * 60 * 24));
          this.getActivitySubmmitedList();
        })
        .catch(() => {
          this.$toastr.error("Error in getting participant details");
        });
    },
    getStudyResponseDetails() {
      this.studyResponse = JSON.parse(window.localStorage.getItem("studyDetailsData"));
    },
    changePrtID(dataObj) {
      this.participantInfo.userDefinedParticipantId = dataObj.newUserDefinedParticipantId;
      this.getParticipantDetails();
    },
    getUserDetails() {
      // As sometimes few of the properties don't set in localstorage, then we use data from this fallback method.
      let userDetails = localStorageService.getItem("userObj");
      this.$api.getProfileDetails(userDetails.id, this.studyId).then(data => {
        this.userDetails = data && data.body;
      });
    },
    getActivityVariablesList(revisionId) {
      let that = this;
      activityService.getActivityVariablesList(revisionId)
      .then(res => {
        that.variablesList = res;
      }, error => {
        this.$toastr.error(
          error.body && error.body.message
            ? error.body.message
            : "Error while getting variable list."
        );
      });
    },
    getActivityRevision() {
      let pathParams = {
        studyId :this.studyId
      }
      let queryParams = {
        surveyResponseTrackerId :this.surveyResponseTrackerId
      }
      this.$api.getActivityRevisionId(pathParams, queryParams)
        .then(res => {
          let revisionId = res.bodyText;
          if (revisionId) {
            this.getActivityVariablesList(revisionId)
          }
        }, error => {
          this.$toastr.error(
            error.body && error.body.message
              ? error.body.message
              : "Error while getting revision Id."
          );
        });
    }
  },
  mounted() {
    this.getUserDetails();
    this.addEventListenerToHideDropdown();
    this.getAllParticipantDetails();
    this.setNavigationOptions();
    this.mlService = new MultilingualService(this.$route, this.studyLanguageId);
    this.getParticipantResponses();
    if (this.activityType === "Activity") {
      this.getParticipantDetails();
    }
  },
  created() {
    this.setActivityDetails();
    this.getStudyResponseDetails();
  },
  destroyed() {
    if (!this.eventListenerToHideDropdown) {
      return;
    }
    document.removeEventListener("click", this.eventListenerToHideDropdown);
  }
};
</script>

<!-- Below Style is for the Tab Component. It is not scoped hence separate style tag -->
<style lang="scss">
.study-participant-response-edit-page {
  /* min-height causing flickering issue in PDEC history */
  .tabs-container {
    .nav-tabs {
      border-bottom-color: #d3dfe4;
      padding-left: 32px;
      .nav-item {
        margin: 0 43px 0 0;
      }

      .nav-link {
        font-size: 14px;
        line-height: 1.43;
        color: #000000;
        padding: 0.9rem 0 0.45rem !important;
        border: none;
        border-bottom: 4px solid transparent;
        font-weight: bold;

        &:focus,
        &:hover {
          border: none;
        }

        &.active {
          font-weight: bold;
          border-bottom: 6px solid #4c8ce4;
        }
      }
    }
  }
}
</style>

<!-- Scoped Style -->

<style lang="scss" scoped>
.study-participant-response-edit-page {
  font-family: "RobotoRegular", sans-serif;
  font-size: 14px;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.task-navigation {
  height: 100px;

  &__previous-icon {
    color: #4a90e2;
    font-size: 20px;
    cursor: pointer;

    &.arrow-disabled {
      color: #dee3e9;
      cursor: inherit;
    }
  }

  &__current-task {
    position: relative;
  }

  &__next-icon {
    color: #4a90e2;
    font-size: 20px;
    cursor: pointer;

    &.arrow-disabled {
      color: #dee3e9;
      cursor: inherit;
    }
  }
}

.tabs-details {
  /* font-family: Robotobold; */
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.current-task__date-dropdown {
  color: #4a4a4a;
}

.col-9,
.col-3 {
  padding: 0;
}

.tabs-container {
  color: #4a4a4a;

  &__left {
    border-right: 1px solid #efefef;
  }

  /* Scrollbar CSS for Mozilla */
  scrollbar-width: thin;

  /* Below is the scrollbar css for Chrome */

  &::-webkit-scrollbar {
    width: 6px;
    background-color: #ffffff;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #4a4a4a;
    border-radius: 2px;
  }
  &::-webkit-scrollbar-track {
    //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #ffffff;
  }
}

.selectedResponse {
  cursor: context-menu;
  .dropdown-icon {
    margin-top: -2px;
    position: absolute;
  }
}
.autocomplete-items {
  position: absolute;
  border: 1px solid #f1f4f8;
  border-top: none;
  z-index: 99;
  /*position the autocomplete items to be the same width as the container:*/
  top: 100%;
  left: -50%;
  right: 0;
  overflow-y: auto;
  border-radius: 2px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.31);
  width: max-content;
  outline: none;

  //Scrollbar CSS for Mozilla
  scrollbar-color: #4a4a4a white; /* thumb and track color */
  scrollbar-width: thin;

  //Below is the scrollbar css for Chrome

  &::-webkit-scrollbar {
    width: 6px;
    background-color: #ffffff;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #4a4a4a;
    border-radius: 2px;
  }
  &::-webkit-scrollbar-track {
    //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #ffffff;
  }

  .day {
    opacity: 0.3;
  }
}
.autocomplete-items .item-detail {
  padding: 7px;
  cursor: pointer;
  background-color: #fff;
  border-bottom: solid 0.5px #f1f4f8;
  font-size: 12px;
  color: #4a4a4a;
  text-align: left;
  &.active {
    background-color: #f1f4f8;
  }
}
.autocomplete-items .item-detail:hover {
  background-color: #f1f4f8;
}

.other-responses-list {
  position: relative;
  display: inline-block;
  /* width: 100%; */
  .selectedResponse {
    cursor: context-menu;
    .dropdown-icon {
      margin-top: -2px;
      position: absolute;
    }
  }
}
.history-content {
  padding: 70px 0px;
  text-align: center;
}
</style>
